import { render, staticRenderFns } from "./FormProjectContent.vue?vue&type=template&id=483520d5&"
import script from "./FormProjectContent.vue?vue&type=script&lang=js&"
export * from "./FormProjectContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports